const NAMESPACE = "themeList";

const KEYS = {
    clearProgramThemeButtonLabel: "clearProgramThemeButtonLabel",
    createNewThemeButtonLabel: "createNewThemeButtonLabel",
    editThemeButtonLabel: "editThemeButtonLabel",
    viewThemeButtonLabel: "viewThemeButtonLabel",
    submitThemeForApprovalButtonLabel: "submitThemeForApprovalButtonLabel",
    unsubmitThemeButtonLabel: "unsubmitThemeButtonLabel",
    applyThemeToProgramButtonLabel: "applyThemeToProgramButtonLabel",
    approveThemeButtonLabel: "approveThemeButtonLabel",
    confirmApproveThemeDialogTitle: "confirmApproveThemeDialogTitle",
    confirmApproveThemeDialogMessage: "confirmApproveThemeDialogMessage",
    revokeThemeApprovalButtonLabel: "revokeThemeApprovalButtonLabel",
    confirmRevokeThemeDialogTitle: "revokeThemeDialogTitle",
    confirmRevokeThemeDialogMessage: "revokeThemeDialogMessage",
    revokeThemeConfirmationInput: "revokeThemeConfirmationInput",
    rejectThemeButtonLabel: "rejectThemeButtonLabel",
    upgradeVersionButtonLabel: "upgradeVersionButtonLabel",
    copyToClipboardButtonLabel: "copyToClipboardButtonLabel",
    nameColumnLabel: "nameColumnLabel",
    statusColumnLabel: "statusColumnLabel",
    createdOnColumnLabel: "createdOnColumnLabel",
    createdByColumnLabel: "createdByColumnLabel",
    lastChangedOnColumnLabel: "lastChangedOnColumnLabel",
    upgradeAllActiveThemesButtonLabel: "upgradeAllActiveThemesButtonLabel",
    isSharedColumnLabel: "isSharedColumnLabel",
    programsAppliedToColumnLabel: "programsAppliedToColumnLabel",
    copyThemeButtonLabel: "copyThemeButtonLabel",
    themeIsPendingTitle: "themeIsPendingTitle",
    themeIsPendingMessage: "themeIsPendingMessage",
    inUseBadgeLabel: "inUseBadgeLabel",
    deleteThemeButtonLabel: "deleteThemeButtonLabel",
    confirmDeleteThemeDialogTitle: "confirmDeleteThemeDialogTitle",
    confirmDeleteThemeDialogMessage: "confirmDeleteThemeDialogMessage",
    confirmApplyThemeToProgramDialogTitle: "confirmApplyThemeToProgramDialogTitle",
    confirmApplyThemeToProgramDialogMessage: "confirmApplyThemeToProgramDialogMessage",
    confirmResetThemeToDefaultDialogTitle: "confirmResetThemeToDefaultDialogTitle",
    confirmResetThemeToDefaultDialogMessage: "confirmResetThemeToDefaultDialogMessage"
};

const MESSAGES = {
    [KEYS.clearProgramThemeButtonLabel]: {
        value: "Restore Default PowerClerk Theme",
        comment: "Text on a button that will clear this program's theme."
    },
    [KEYS.createNewThemeButtonLabel]: {
        value: "New Theme",
        comment: "Text on a button that will take the user to a page to create a new theme."
    },
    [KEYS.editThemeButtonLabel]: {
        value: "Edit",
        comment: "Text on a button that will take the user to a page to edit this theme."
    },
    [KEYS.viewThemeButtonLabel]: {
        value: "View",
        comment: "Text on a button that will take the user to a page to view this theme."
    },
    [KEYS.submitThemeForApprovalButtonLabel]: {
        value: "Submit for Approval",
        comment: "Text on a button that will submit this theme for approval."
    },
    [KEYS.unsubmitThemeButtonLabel]: {
        value: "Unsubmit",
        comment: "Text on a button that will unsubmit this theme."
    },
    [KEYS.applyThemeToProgramButtonLabel]: {
        value: "Apply to Program",
        comment: "Text on a button that will apply this theme to a program."
    },
    [KEYS.approveThemeButtonLabel]: {
        value: "Approve",
        comment: "Text on a button that will approve this theme."
    },
    [KEYS.confirmApproveThemeDialogTitle]: {
        value: "Confirm Theme Approval",
        comment: "Title for a dialog that asks the user to confirm approving this theme."
    },
    [KEYS.confirmApproveThemeDialogMessage]: {
        value: "Approving this theme will make it available for admins with the Edit Themes permission to apply to any program in this agency. Are you sure?",
        comment: "Message for a dialog that asks the user to confirm approving this theme."
    },
    [KEYS.revokeThemeApprovalButtonLabel]: {
        value: "Revoke Approval",
        comment: "Text on a button that will revoke this theme's approval."
    },
    [KEYS.confirmRevokeThemeDialogTitle]: {
        value: "Confirm Revoke Approved Theme",
        comment: "Title for a dialog that asks the user to confirm revoking theme approval."
    },
    [KEYS.confirmRevokeThemeDialogMessage]: {
        value:
            "Revoking this theme's approval will make it unavailable to be applied, and will immediately cause any " +
            "programs applying this theme to revert the PowerClerk default theme. Are you sure?",
        comment: "Message for a dialog that asks the user to confirm revoking theme approval."
    },
    [KEYS.revokeThemeConfirmationInput]: {
        value: "Revoke approved theme",
        comment: "Confirmation message for revoking theme approval."
    },
    [KEYS.rejectThemeButtonLabel]: { value: "Reject", comment: "Text on a button that will reject this theme." },
    [KEYS.upgradeVersionButtonLabel]: {
        value: "Upgrade Version",
        comment: "Text on a button that will upgrade this theme's version."
    },
    [KEYS.copyToClipboardButtonLabel]: {
        value: "Copy Config",
        comment: "Text on a button that copies the theme config to the clipboard"
    },
    [KEYS.nameColumnLabel]: { value: "Name", comment: "Header for the Name column in the theme list." },
    [KEYS.statusColumnLabel]: { value: "Status", comment: "Header for the Status column in the theme list." },
    [KEYS.createdOnColumnLabel]: {
        value: "Created Date",
        comment: "Header for the (theme creation) Time Created column in the theme list."
    },
    [KEYS.createdByColumnLabel]: {
        value: "Created By",
        comment: "Header for the (theme creation) Created By column in the theme list."
    },
    [KEYS.lastChangedOnColumnLabel]: {
        value: "Last Changed Date",
        comment: "Header for the column that shows the last time this theme was changed."
    },
    [KEYS.upgradeAllActiveThemesButtonLabel]: {
        value: "Upgrade All Active Themes",
        comment: "Text on a button that will upgrade all active themes."
    },
    [KEYS.isSharedColumnLabel]: {
        value: "Shared",
        comment: "Header for the column that indicates this theme is shared with others in the same agency"
    },
    [KEYS.programsAppliedToColumnLabel]: {
        value: "Programs Applied To",
        comment: "Header for the column that lists the programs this theme is applied to."
    },
    [KEYS.copyThemeButtonLabel]: {
        value: "Copy",
        comment: "Text on a button that will copy this theme."
    },
    [KEYS.themeIsPendingTitle]: {
        value: "Theme is Pending",
        comment: "Title for a dialog that informs the user that this theme is pending."
    },
    [KEYS.themeIsPendingMessage]: {
        value: "The selected theme has been submitted for approval and can no longer be edited. To have this theme approved, please contact PowerClerk support through a support ticket or by email.",
        comment: "Message for a dialog that informs the user that this theme is pending."
    },
    [KEYS.inUseBadgeLabel]: {
        value: "In Use",
        comment: "Text on a badge that indicates this theme is currently in use."
    },
    [KEYS.deleteThemeButtonLabel]: {
        value: "Delete",
        comment: "Text on a button that will delete this theme."
    },
    [KEYS.confirmDeleteThemeDialogTitle]: {
        value: "Confirm Delete Theme",
        comment: "Title for a dialog that asks the user to confirm deleting this theme."
    },
    [KEYS.confirmDeleteThemeDialogMessage]: {
        value: "Are you sure you want to delete this theme? This action cannot be undone.",
        comment: "Message for a dialog that asks the user to confirm deleting this theme."
    },
    [KEYS.confirmApplyThemeToProgramDialogTitle]: {
        value: "Confirm Apply Theme",
        comment: "Title for a dialog that asks the user to confirm applying this theme to a program."
    },
    [KEYS.confirmApplyThemeToProgramDialogMessage]: {
        value: "Are you sure you want to apply this theme to the program?",
        comment: "Message for a dialog that asks the user to confirm applying this theme to a program."
    },
    [KEYS.confirmResetThemeToDefaultDialogTitle]: {
        value: "Confirm Reset Theme",
        comment: "Title for a dialog that asks the user to confirm resetting this theme to default."
    },
    [KEYS.confirmResetThemeToDefaultDialogMessage]: {
        value: "Are you sure you want to reset the theme to the default PowerClerk theme?",
        comment: "Message for a dialog that asks the user to confirm resetting this theme to default."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
